import React, { useState, useContext, useEffect } from 'react';
import requests from '../utils/requests';
import functions from '../utils/functions';
import LabeledInput from './LabeledInput';
import { PersonContext } from '../providers/Person';
import { s } from '../Style.jsx';

const OrderSummary = ({ vendors, setViewingOrder, deleteOrder, order, accounting, setOrders, orders = [] }) => {
    const { auth } = useContext(PersonContext);

    const tax = (order?.deliveryFeeTax);
    const total = (order?.deliveryFee || 0) + (order?.deliveryFeeTax || 0) + (order?.subtotal || 0) + (order?.stripeFee || 0);

    const [settings, setSettings] = useState({});
    useEffect(() => {
        requests.getSettings(auth).then(settings => {
            setSettings(settings);
        });
    }, []);

    return <>
        <div style={s.row}>
            <h3 style={{ marginBottom: 10 }}>Order Summary</h3>
        </div>
        <div style={s.box}>
            <div style={{ ...s.table, marginBottom: 0 }}>
                <div style={s.cell(0)}>
                    <span style={{ fontSize: 14 }}>Subtotal</span>
                    <span style={{ fontSize: 14, opacity: functions.formatMoney(order?.subtotal, 1) > 0 ? 1 : .3 }}>${functions.formatMoney(order?.subtotal)}</span>
                </div>
                <div style={s.cell(1)}>
                    <span style={{ fontSize: 14 }}>Delivery Fee</span>
                    <span style={{ fontSize: 14, opacity: functions.formatMoney(order?.deliveryFee, 1) > 0 ? 1 : .3 }}>${functions.formatMoney(order?.deliveryFee)}</span>
                </div>
                <div style={s.cell(0)}>
                    <span style={{ fontSize: 14 }}>Tax</span>
                    <span style={{ fontSize: 14, opacity: functions.formatMoney(tax, 1) > 0 ? 1 : .3 }}>${functions.formatMoney(tax)}</span>
                </div>
                <div style={s.cell(1)}>
                    <span style={{ fontSize: 14 }}>Stripe Fee</span>
                    <span style={{ fontSize: 14, opacity: functions.formatMoney(order.stripeFee, 1) > 0 ? 1 : .3 }}>${functions.formatMoney(order.stripeFee)}</span>
                </div>
                <div style={{ ...s.cell(0) }}>
                    <span style={{ fontSize: 14, flex: 1 }}>Total</span>
                    <h3 style={{ margin: "10px 0", fontSize: 18 }}>${functions.formatMoney(total)}</h3>
                </div>
                {order.method && <div style={{ ...s.cell(1) }}>
                    <span style={{ fontSize: 14, flex: 1 }}>Payment Method</span>
                    <span style={{ fontSize: 14, fontWeight: "bold" }}>{order.method?.toUpperCase()}</span>
                </div>}
                {accounting && <>
                    <span style={{ flex: 1 }}></span>
                    {order.payment_status !== "paid" && <button
                        onClick={() => {
                            setViewingOrder({ ...order, stripeEnabled: !order.stripeEnabled, stripeFee: order.stripeEnabled ? 0 : settings.stripeFee });
                            requests.updateOrder({ auth, id: order.id, values: { stripeEnabled: !order.stripeEnabled, stripeFee: order.stripeEnabled ? 0 : settings.stripeFee } });
                        }}
                    >{!order?.stripeEnabled ? "Enable Stripe" : "Disable Stripe"}</button>}
                    <button
                        onClick={() => {
                            setViewingOrder({ ...order, payment_status: order.payment_status !== "paid" ? "paid" : "pending" });
                            requests.updateOrder({ auth, id: order.id, values: { payment_status: order.payment_status !== "paid" ? "paid" : "pending" } });
                        }}
                    >{order.payment_status !== "paid" ? "Mark as Paid" : "Mark as Not Paid"}</button>
                </>}
            </div>
        </div>


    </>;
}

export default OrderSummary;